module.exports = __webpack_public_path__ + "img/1523042329.bb7e7638.jpg";